import React, { useState } from 'react';
import './styles.css';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from './Page/Home';
import Productos from './Page/Productos';
import Contacto from './Page/Contacto';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<string>('home');

  const renderPage = (): JSX.Element => {
    switch(currentPage) {
      case 'productos':
        return <Productos />;
      case 'contacto':
        return <Contacto />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="app">
      <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <main className="main-content">
        {renderPage()}
      </main>
      <Footer />
    </div>
  );
};

export default App;